import { FlexBox, CommonLabelText } from "@brg/ui";
import { useTranslation } from "react-i18next";
import ViewTypeController from "shared/components/ViewTypeController/ViewTypeController";
import { ColumnLabelGroup } from "../styles";

const ProjectStructureField = () => {
    const { t } = useTranslation();
    return (
        <ColumnLabelGroup direction="column" directionMobile="column">
            <CommonLabelText>
                {t('project_edit.project_structure')}
            </CommonLabelText>
            <ViewTypeController sizesTypes />
        </ColumnLabelGroup>
    )
}

export default ProjectStructureField;import { FlexBox, CommonLabelText } from "@brg/ui";
import { useTranslation } from "react-i18next";
import ViewTypeController from "shared/components/ViewTypeController/ViewTypeController";
import { ColumnLabelGroup } from "../styles";

const ProjectStructureField = () => {
    const { t } = useTranslation();
    return (
        <ColumnLabelGroup direction="column" directionMobile="column">
            <CommonLabelText>
                {t('project_edit.project_structure')}
            </CommonLabelText>
            <ViewTypeController sizesTypes />
        </ColumnLabelGroup>
    )
}

export default ProjectStructureField;